import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Plain client for public (unauthenticated) endpoints — no auth redirect side-effects.
const publicApi = axios.create({ baseURL: API });

export default publicApi;
